<template>
  <div class="index-sale-setting">
    <div class="index-sale-item">
      <van-radio-group class="radio" v-model="value" direction="horizontal">
        <!-- <van-radio :name="0" class="index-sale-check">
          <div>
            <h5>按活动优惠后实付款退款</h5>
            <p>按已享受活动优惠后的实付款退。</p>
          </div>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
          </template>
        </van-radio>
        <van-radio :name="1" class="index-sale-check">
          <div>
            <h5>不支持退货</h5>
            <p>已享受活动优惠，不支持退货。</p>
          </div>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
          </template>
        </van-radio> -->

        <van-radio v-for="item in afterTemplateList" :key="item.value" :name="item.value" class="index-sale-check">
          <div>
            <h5>{{item.desc}}</h5>
            <!-- <p>按已享受活动优惠后的实付款退。</p> -->
          </div>
          <template #icon="props">
            <img class="img-icon" :src="props.checked ? $theme.assist_icon_radio_default : $theme.assist_icon_radio_default_unselect" />
          </template>
        </van-radio>

      </van-radio-group>
    </div>

    <FixedBtn label="保存" @btnClick="onBtnClick"></FixedBtn>
  </div>
</template>

<script>
import FixedBtn from './components/fixed_btn';
import utils from "@/utils/common";
import http from "@/utils/axios";
export default {
  data() {
    return {
      clientWidth: window.clientWidth / 375,
      //   value: this.$route.query.saleAfterMode || 0,
      value: this.$route.query.afterTemplate || 0,
      afterTemplateList: [],
    }
  },
  created() {
    this.$loading.hide()
    http({
      url: "/order/admin/branch/afterTemplate",
      method: "get",
    }).then((res) => {
      if (res.code == 200) {
        console.log(res);
        this.afterTemplateList = res.data
        this.$loading.hide();
      }
    }).catch(() => {
      this.$loading.hide();
    });

  },
  methods: {
    onBtnClick() {
      //   this.$store.dispatch('saveDiscountKey', { key: 'saleAfterMode', val: this.value })
      this.$store.dispatch('saveDiscountKey', { key: 'afterTemplate', val: this.value })
      utils.goBack()
    }
  },
  components: {
    FixedBtn
  }
}
</script>

<style lang="less" scoped>
.index-sale-setting {
  padding: 0 30px;
  font-size: 24px;
  .index-sale-item {
    display: flex;
    padding: 30px 0;
    background-color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    padding-left: 20px;
    .index-sale-check {
      margin-bottom: 20px;
      width: 100%;
      margin-top: 16px;
    }
    h5 {
      font-size: 28px;
      font-weight: 500;
    }
    p {
      margin-top: 10px;
      color: #999;
    }
    .img-icon {
      width: 40px;
      height: 40px;
    }
  }
}
</style>